<script setup lang="ts">
import { computed } from 'vue'
import { numKtoM } from '@/helpers/formating'
import { t } from '@/locales/i18n'
import GwText from '@/components/lib/base/GwText/GwText.vue'

import { type TscoreBreakdown } from '@/store/api/gql/hands/queries'
import { type GTOScoreColors } from '@/components/lib/base/GwSurface/gwSurfaceUtils'

type Props = {
  scoreBreakdown?: TscoreBreakdown
}

const props = defineProps<Props>()

const options = computed(() => {
  const total =
    (props.scoreBreakdown?.best_moves || 0) +
    (props.scoreBreakdown?.correct_moves || 0) +
    (props.scoreBreakdown?.inaccuracies || 0) +
    (props.scoreBreakdown?.mistake_moves || 0) +
    (props.scoreBreakdown?.blunders || 0)
  const getPercentage = (value: number) => (value / total) * 100
  return [
    {
      key: 'perfect',
      bg: 'best_move',
      value: props.scoreBreakdown?.best_moves || 0,
      percentage: getPercentage(props.scoreBreakdown?.best_moves || 1),
    },
    {
      key: 'good',
      bg: 'correct_move',
      value: props.scoreBreakdown?.correct_moves || 0,
      percentage: getPercentage(props.scoreBreakdown?.correct_moves || 1),
    },
    {
      key: 'innacurate',
      bg: 'inaccuracy',
      value: props.scoreBreakdown?.inaccuracies || 0,
      percentage: getPercentage(props.scoreBreakdown?.inaccuracies || 1),
    },
    {
      key: 'mistake',
      bg: 'mistake',
      value: props.scoreBreakdown?.mistake_moves || 0,
      percentage: getPercentage(props.scoreBreakdown?.mistake_moves || 1),
    },
    {
      key: 'blunder',
      bg: 'blunder',
      value: props.scoreBreakdown?.blunders || 0,
      percentage: getPercentage(props.scoreBreakdown?.blunders || 1),
    },
  ]
}) as unknown as {
  key: string
  bg: GTOScoreColors
  value: number
  percentage: number
}[]
</script>
<template>
  <div
    class="gto_score_chart f-column"
    style="gap: var(--app-gap-3)"
  >
    <div
      v-for="oo in options"
      :key="oo.percentage"
      class="f-column w-100"
      style="gap: var(--app-gap-1)"
    >
      <div class="d-flex">
        <GwText variant="text_white_normal_500">
          {{ t(`hhv3.stats_chart.${oo.key}`) }}
        </GwText>
        <GwText
          class="ml-auto"
          variant="text_white_normal_500"
        >
          {{ numKtoM(oo.value, 1000, 2) }}
        </GwText>
      </div>
      <div
        class="w-100 position-relative"
        style="
          background: var(--app-light-2);
          height: var(--app-height-3);
          border-radius: var(--app-rad-2);
        "
      >
        <div
          style="position: absolute; left: 0; top: 0; height: 100%; border-radius: var(--app-rad-2)"
          :style="`background: var(--app-clr-${oo.bg}); width: ${oo.percentage}%`"
        />
      </div>
    </div>
  </div>
</template>
